Vue.component('nav-item', {
  props: ['item'],
  template: '#vue-nav-item',
  methods: {
    setSearch: function (params) {
      router.push({
        name: 'search',
        query: {
          type: params.type,
          destination: params.destination,
          start_date: params.start_date,
          end_date: params.end_date
        }
      });
    }
  }
});

Vue.component('nav-bar', {
  template: '#vue-nav-bar',
  data: function () {
    return {
      navElements: []
    }
  },
  computed: {
    logo: function () {
      return store.state.config.logo;
    },
    logo2: function () {
      return store.state.config.logo2;
    },
    tekst: function () {
      return store.state.config.tekst;
    },
    kontakt: function () {
      return store.state.config.kontakt;
    }
  },
  created: function () {
    this.getList()
  },
  methods: {
    getList: function () {
      const self = this;
      $.post("/back/NavHeader.php", null, function (result, textStatus) {
        if (result.navElements !== null) {
          self.navElements = result.navElements;
        }
      }, "json");
    }
  }
});
